import axios from "axios";
export default {
    btnNextMonth: null,
    btnPrevMonth: null,
    calendarBody: null,
    calendarYear: null,
    calendarMonth: null,
    init() {

        this.btnNextMonth = document.querySelector(".js-calendar-next-month");
        this.btnPrevMonth = document.querySelector(".js-calendar-prev-month");
        this.calendarBody = document.querySelector(".js-calendar-body");

        if(!this.btnNextMonth || !this.btnPrevMonth || !this.calendarBody){
            return;
        }

        this.btnNextMonth.addEventListener("click", (e) => {
            this.calendarYear = this.btnNextMonth.dataset.year;
            this.calendarMonth = this.btnNextMonth.dataset.month;
            this.getBody();
        });

        this.btnPrevMonth.addEventListener("click", (e) => {
            this.calendarYear = this.btnPrevMonth.dataset.year;
            this.calendarMonth = this.btnPrevMonth.dataset.month;
            this.getBody();
        });


    },
    getBody() {
        _ = this;
        _.calendarBody.innerHTML = '<div style="height: 337px; width: 323px"><div class="search__loading-spinner"></div></div> ';
        axios({
            method: "get",
            url: "/actions/visitmr/calendar-render/index?y="+_.calendarYear+"&m="+_.calendarMonth,
        }).then(function (response) {
            _.calendarBody.innerHTML = response.data;
            _.init();
        });
    },
};
